import React, { useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MESSAGES_INFO, RESET_AROUND_MESSAGES_REQUEST } from "../../redux/actions/messagesActions";
import { checkForBadWords } from "../../helpers/Dialogs";
import { IsMobile } from "../../helpers/Helpers";
import PinnedMessages from "./pinned-messages";
import PinnedMessagesSlider from "./pinned-messages-slider";
var PinnedMessageContainer = function (_a) {
    var dialogId = _a.dialogId, chatType = _a.chatType;
    var messages = useSelector(function (state) { return state; }).messages;
    var dispatch = useDispatch();
    var isMobile = IsMobile();
    var pinnedMessages = messages.pinnedMessages;
    if (!pinnedMessages) {
        return null;
    }
    var data = useMemo(function () {
        return pinnedMessages.map(function (message) {
            var _a;
            return {
                title: (_a = message === null || message === void 0 ? void 0 : message.user) === null || _a === void 0 ? void 0 : _a.name,
                description: checkForBadWords(message),
                id: message === null || message === void 0 ? void 0 : message.id,
            };
        });
    }, [pinnedMessages]);
    var getMessage = useCallback(function (messageId) {
        var messageElement = document.querySelector("[id='" + messageId + "']");
        if (messageElement) {
            var child_1 = messageElement.firstElementChild || messageElement.firstChild;
            messageElement.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
            child_1.classList.add("highlight-repoted-message");
            setTimeout(function () { return child_1.classList.remove("highlight-repoted-message"); }, 2000);
        }
        else {
            dispatch({
                type: MESSAGES_INFO,
                payload: {
                    dialog_id: dialogId,
                    type_chat: chatType,
                    blockReloadChat: true,
                    isBlockedScroll: true,
                    loaderDisabled: true,
                    aroundMessageId: messageId,
                    noResetForNewMessages: true,
                },
                onFinish: function () {
                    setTimeout(function () {
                        var messageElement = document.querySelector("[id='" + messageId + "']");
                        if (messageElement) {
                            var child_2 = messageElement.firstElementChild || messageElement.firstChild;
                            messageElement.scrollIntoView({
                                behavior: "smooth",
                                block: "nearest",
                                inline: "start",
                            });
                            child_2.classList.add("highlight-repoted-message");
                            setTimeout(function () {
                                child_2.classList.remove("highlight-repoted-message");
                            }, 2000);
                        }
                        dispatch({ type: RESET_AROUND_MESSAGES_REQUEST });
                    }, 500);
                },
            });
        }
    }, [dialogId]);
    return (React.createElement(React.Fragment, null, isMobile ? (React.createElement(PinnedMessagesSlider, { data: data, getMessage: getMessage })) : (React.createElement(PinnedMessages, { data: data, getMessage: getMessage }))));
};
export default React.memo(PinnedMessageContainer);
